import { FixaInlineMessageVariants } from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { useCallback, useRef, useState } from "react";
import { BaseNotificationItem } from "./notifications.types";

export type ErrorNotificationItem = BaseNotificationItem & {
  variant?: FixaInlineMessageVariants;
};

type ShowErrorArgs = Omit<ErrorNotificationItem, "id">;

export type UseErrorNotificationsResult = {
  errors: ErrorNotificationItem[];
  showError: (notification: ShowErrorArgs) => number;
  removeError: (notificationId: number) => void;
  clearErrors: () => void;
};

export const useErrorNotificationsState = (): UseErrorNotificationsResult => {
  const [errors, setErrors] = useState<ErrorNotificationItem[]>([]);
  const nextNotificationIdRef = useRef(0);

  const removeError = useCallback((notificationId: number) => {
    setErrors((previousErrors) =>
      previousErrors.filter(
        (notification) => notification.id !== notificationId
      )
    );
  }, []);

  const showError = useCallback(({ text, title, variant }: ShowErrorArgs) => {
    const notificationId = nextNotificationIdRef.current;
    nextNotificationIdRef.current += 1;

    setErrors((previousErrors) => [
      ...previousErrors,
      { id: notificationId, text, title, variant },
    ]);

    return notificationId;
  }, []);

  const clearErrors = useCallback(() => {
    setErrors([]);
  }, []);

  return {
    errors,
    showError,
    removeError,
    clearErrors,
  };
};
